import { render, staticRenderFns } from "./ComRawLoader.vue?vue&type=template&id=0fcd39a6&scoped=true"
import script from "./ComRawLoader.vue?vue&type=script&lang=js"
export * from "./ComRawLoader.vue?vue&type=script&lang=js"
import style0 from "./ComRawLoader.vue?vue&type=style&index=0&id=0fcd39a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd39a6",
  null
  
)

export default component.exports